import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-rules-terms',
  templateUrl: './rules-terms-KSA.component.html',
  styleUrls: ['./rules-terms-KSA.component.scss']
})
export class RulesTermsTecnoKSAComponent implements OnInit {
  constructor(public globalService:GlobalService) { }

  ngOnInit(): void {
  }


}
